import { createAsyncThunk } from '@reduxjs/toolkit'
import { fetchWrapper } from '../../_helpers/fetch-wrapper'
import { AUTH, AUTH_CHECK_ACCESS } from '../../constants/endpoints';

export const loginThunk = createAsyncThunk(
    'auth/login',
    async ({ login, password }: any) => {
        let token: any[] = await fetchWrapper.post(AUTH, { login, password });
        return token;
    }
);

export const checkAccessThunk = createAsyncThunk<boolean>(
    'auth/checkAccess',
    async () => {
        let isAuthenticated = await fetchWrapper.get(AUTH_CHECK_ACCESS);
        return isAuthenticated;
    }
);
